export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.d3002589.worker.js");
}
